<template>
  <div class="h-full">
    <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
      <!-- 表格部分 -->
      <el-col class="h-full" :span="24">
        <!-- 表头搜索 -->
        <el-row :gutter="10" type="flex" align="middle" class="mb-10px">
          <el-col :span="24">
            <el-input
              size="small"
              v-model="keyword"
              clearable
              placeholder="请输入"
              class="w-200px mr-10px"
            ></el-input>
            <el-button type="primary" @click="getErrorDetailLits">{{ $t('search') }}</el-button>
            <el-button type="primary" @click="exportData">下载</el-button>
            <el-button class="ml-0px float-right" @click="goBack">{{ $t('返回') }}</el-button>
            <!-- <el-button
              class="ml-0px mr-10px float-right"
              type="primary"
              v-if="type !== 'look'"
              :loading="submitLoading"
              @click="submitForReview"
              >{{ $t('提交审核') }}</el-button
            > -->
          </el-col>
        </el-row>
        <!-- 表格列表 -->
        <el-row class="tableDiv">
          <div class="h-full">
            <!-- @cell-dblclick="tabClick" -->
            <el-table
              :data="sourceDataList"
              v-loading="listLoading"
              border
              :header-cell-style="headStyle"
              height="100%"
              ref="multipleTable"
              stripe
              row-key="id"
              @selection-change="selectChange"
              :row-class-name="tableRowClassName"
            >
              <el-table-column
                align="center"
                v-for="(tItem, tIndex) in tableHeader"
                :key="tIndex"
                :label="tItem.name"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="bottom"
                    v-if="scope.row.dataValueDtos[tIndex].errValueList.length !== 0"
                    popper-class="wrap"
                    trigger="hover"
                  >
                    <div class="triangle"></div>
                    <ul>
                      <li
                        v-for="(item, index) in scope.row.dataValueDtos[tIndex].errValueList"
                        :key="index"
                        class="tc"
                      >
                        不满足{{ item }}规则
                      </li>
                    </ul>
                    <div slot="reference">
                      <div
                        :class="{
                          'error-tips': true,
                          'border-red':
                            scope.row.dataValueDtos[tIndex].errValueList.length !== 0 &&
                            !scope.row.dataValueDtos[tIndex].afterValue,
                        }"
                        class="ell"
                      >
                        <el-input
                          size="samll"
                          ref="tableInput"
                          v-if="
                            scope.row.dataValueDtos[tIndex].errValueList.length !== 0 &&
                              dbClickPosition.includes(scope.row.dataValueDtos[tIndex].position)
                          "
                          v-model="scope.row.dataValueDtos[tIndex].afterValue"
                          @blur="
                            () => {
                              removeClass(scope.row)
                            }
                          "
                        ></el-input>
                        <!-- 这儿使用template包裹是为了尽可能的不改变element-ui已封装好的样式能够作用到重新渲染的节点上 -->
                        <template v-else-if="scope.row.dataValueDtos[tIndex].afterValue === ''">
                          {{ scope.row.dataValueDtos[tIndex].beforeValue }}
                        </template>
                        <template v-else>
                          {{ scope.row.dataValueDtos[tIndex].afterValue }}
                        </template>
                      </div>
                    </div>
                  </el-popover>
                  <!-- 这儿使用template包裹是为了尽可能的不改变element-ui已封装好的样式能够作用到重新渲染的节点上 -->
                  <template v-else>
                    {{ scope.row.dataValueDtos[tIndex].beforeValue }}
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-row>

        <el-pagination
          class="mt-20px float-right"
          background
          @size-change="documentListDataSize"
          @current-change="documentListData"
          :current-page.sync="sourceTableParam.pageNo"
          :page-sizes="$pageSizeAll"
          :page-size.sync="sourceTableParam.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNumberL"
        ></el-pagination>
      </el-col>
    </el-card>
  </div>
</template>

<script type="text/ecmascript-6">
import StandardManagementService from '@/services/thApi/StdClassDataBatch'
import fnMixin from '@/assets/js/fnMixins'

export default {
  name: 'errorDetail',
  mixins: [fnMixin],
  components: {},
  watch: {},
  data() {
    return {
      keyword: '',
      instanceid: null,
      userId: null,
      tabClickLabel: null,
      tabClickIndex: null,
      dataSave: null,
      flag: true,
      sourceTableParam: {
        pageNo: 1,
        pageSize: 15,
      },
      type: null,
      tableHeader: [],
      tableDataDetail: [],
      tableId: '',
      taskId: '',
      visible: true,
      listLoading: false,
      dataDescription: '',
      totalNumberL: 0,
      sourceDataList: [],
      dbClickPosition: [], // 鼠标双击位置
      submitLoading: false, // 提交按钮loading
    }
  },
  created() {
    this.tableId = this.$route.query.class_id
    this.taskId = this.$route.query.task_run_id
    this.type = this.$route.query.type
    this.getErrorDetailLits()
  },
  mounted() {},
  beforeDestroy() {},
  destroyed() {},

  methods: {
    async exportData() {
      const res = await StandardManagementService.exportData({
        pageIndex: 1,
        pageSize: 999,
        taskRunRecordId: this.taskId,
        stdClassId: this.tableId,
      })
      if (res) {
        this.downLoadBlob({
          name: '数据问题清单导出结果.xlsx',
          data: res,
        })
      }
    },
    // editBlur(row) {
    //   this.tabClickIndex = null
    //   this.tabClickLabel = ''
    // },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    removeClass(itemRow) {
      const positionIndex = _.findIndex(
        this.dbClickPosition,
        itemRow.dataValueDtos[itemRow.index].position
      )
      this.dbClickPosition.splice(positionIndex, 1)
    },
    tabClick(row, column) {
      if (!row.isEditColumn.includes(column.label)) return
      const columnIndex = _.findIndex(row.dataValueDtos, (dtoItem) => {
        return dtoItem.label === column.label
      })
      if (
        columnIndex !== -1 &&
        this.dbClickPosition.includes(row.dataValueDtos[columnIndex].position)
      ) {
        return
      }
      if (row.dataValueDtos[columnIndex].errValueList.length) {
        this.dbClickPosition.push(row.dataValueDtos[columnIndex].position)
      }
    },
    selectChange() {},
    // 搜索
    searchSourceData() {},
    // 返回上一页
    goBack() {
      this.$router.go(-1)
    },
    // 删除
    addSourceata() {},
    // 刷新
    refreshSourceData() {},
    // 提交审核
    async submitForReview() {
      const borderRedArr = document.getElementsByClassName('border-red')
      if (borderRedArr.length > 0) {
        this.$message.warning('请将错误修改完成提交')
        return
      }
      const params = []
      _.forEach(this.sourceDataList, (item) => {
        _.forEach(item.dataValueDtos, (dItem, dIndex) => {
          if (dItem.afterValue !== '') {
            params.push({
              taskRunRecordId: this.taskId,
              classId: this.tableId,
              rowNo: item.index,
              columnName: this.tableHeader[dIndex].columnName,
              beforeValue: dItem.beforeValue,
              afterValue: dItem.afterValue,
              dataPrimaryKey: dItem.dataPrimaryKey,
              classAttributeId: this.tableHeader[dIndex].id,
              classAttributeName: this.tableHeader[dIndex].name,
            })
          }
        })
      })
      this.submitLoading = true
      const resData = await StandardManagementService.submitEorrDetailForReview(params)
      this.submitLoading = false
      if (resData && resData.code === 0) {
        this.$message.success('提交审核成功')
        this.goBack()
        this.getErrorDetailLits()
      }
    },
    // 编辑
    editSourceData() {},
    headStyle() {
      return 'text-align:center'
    },
    // 分页器
    documentListData() {
      this.getErrorDetailLits()
    },
    documentListDataSize() {
      this.sourceTableParam.pageNo = 1
      this.getErrorDetailLits()
    },
    // 获取错误详情
    async getErrorDetailLits() {
      this.sourceDataList = []
      this.listLoading = true
      const res = await StandardManagementService.getErrorData({
        pageIndex: this.sourceTableParam.pageNo,
        pageSize: this.sourceTableParam.pageSize,
        taskRunRecordId: this.taskId,
        stdClassId: this.tableId,
        filter: this.keyword,
      })
      this.listLoading = false
      if (res && res.data && res.code === 0) {
        // if (!res.data.data) {
        //   this.$message.warning('当前整改数据未更新，请返回上一级页面查看最新整改数据')
        //   // this.$router.push('/dataQuality/dataRectification')
        //   return
        // }
        this.dataSave = res.data
        this.tableHeader = res.data.headerInfos
        this.totalNumberL = res.data.totalCount
        const tableData = res.data.data
        _.forEach(tableData, (sourceItem, sourceIndex) => {
          const sourceOne = {
            dataValueDtos: [], // table渲染的数据
            isEditColumn: [], // 可编辑列
          }
          Object.keys(sourceItem).forEach((key) => {
            const rowIndex = _.findIndex(this.tableHeader, ['columnName', key])
            if (rowIndex === -1) return
            const label = _.find(this.tableHeader, { columnName: key }).name
            const someOne = {
              beforeValue: sourceItem[key].value,
              afterValue: '',
              errValueList: sourceItem[key].exceptions ? sourceItem[key].exceptions : [],
              dataPrimaryKey: sourceItem[key].dataPrimaryKey,
            }
            if (sourceItem[key].exceptions && sourceItem[key].exceptions.length > 0) {
              someOne.label = label
              someOne.position = `${sourceIndex},${rowIndex}`
              sourceOne.isEditColumn.push(label)
            }
            // header和data的顺序保持一致
            sourceOne.dataValueDtos[rowIndex] = someOne
            // sourceOne.id = sourceItem.id.value
          })
          this.sourceDataList.push(sourceOne)
        })
        // 固定加一列 错误数据
        this.tableHeader.push({
          columnName: 'errorData',
          name: '错误数据',
        })
        _.map(this.sourceDataList, (sourceItem) => {
          const errOne = {
            beforeValue: '',
            afterValue: '',
            errValueList: [],
            dataPrimaryKey: '',
          }
          _.map(sourceItem.dataValueDtos, (sourceOne) => {
            if (sourceOne.errValueList && sourceOne.errValueList.length > 0) {
              _.map(sourceOne.errValueList, (errItem, errIndex) => {
                if (errOne.beforeValue === '') {
                  if (errIndex === 0) {
                    errOne.beforeValue = `${sourceOne.label}：不满足${errItem}规则`
                  } else {
                    errOne.beforeValue = `${errOne.beforeValue}、不满足${errItem}规则`
                  }
                } else if (errOne.beforeValue !== '') {
                  if (errIndex === 0) {
                    errOne.beforeValue = `${errOne.beforeValue}；${sourceOne.label}：不满足${errItem}规则`
                  } else {
                    errOne.beforeValue = `${errOne.beforeValue}、不满足${errItem}规则`
                  }
                }
              })
            }
            return sourceOne
          })
          sourceItem.dataValueDtos.push(errOne)
          return sourceItem
        })
      }
    },
  },
}
</script>

<style ref="stylesheet/scss" type="text/scss" lang="scss" scoped>

.name-wrapper {
  color: #6894f3;
}
.tips {
  position: absolute;
  height: 40px;
  padding: 0 5px;
  line-height: 40px;
  background-color: red;
  z-index: 9 !important;
  border: 1px solid rgb(252, 252, 252);
  top: -7px;
  right: -40px;
  color: aliceblue;
  font-weight: 500;
}
/deep/.is-center {
  position: relative !important;
}
.start {
  position: absolute;
  border-top: 10px solid transparent;
  display: inline-block;
  border-bottom: 10px solid transparent;
  border-right: 10px solid red;
  border-left: 10px solid transparent;
  left: -20px;
  top: 5px;
  z-index: 200 !important;
}
/deep/.el-popper {
  width: 20px;
  right: 0;
  top: 50px;
  background-color: red;
}
// .triangle {
//   position: absolute;
//   top: -20px;
//   left: 50%;
//   border-top: 10px solid transparent;
//   border-bottom: 10px solid #ff1818;
//   border-left: 10px solid transparent;
//   border-right: 10px solid transparent;
// }
/deep/.el-table tr {
  height: 36px;
}
/deep/.el-popover {
  color: white;
}
.input_style {
  height: 23px;
  width: 120px;
}
.current-cell .el-input {
  display: block !important;
}
.current-cell .el-input + span {
  display: none;
}
/deep/.is-center {
  position: relative !important;
}
// /deep/ .cell span {
//   display: inline-block;
//   width: 100%;
//   height: 100%;
// }
/deep/ .el-table__row td {
  // margin: 0;
  // padding: 0px;

  .cell {
    // height: 36px; // 为了能撑起红色框
    // padding: 0;
    // margin: 0;

    span:first-child {
      display: inline-block;
      width: 100%;
      height: 100%;

      .el-popover__reference {
        height: 100%;

        * {
          border-color: red;
        }
      }
    }
  }
}

.error-tips {
  width: 100%;
  height: 100%;
  // padding: 2px 5px;

  /deep/ .el-input {
    height: 100%;

    .el-input__inner {
      height: 100%;
    }
  }
}

.border-red {
  // border: 1px solid red;
  color: red;
}

// /deep/ .el-table .cell {
//   line-height: 36px;
// }

/deep/ .el-table__body-wrapper {
  overflow: auto;
}
.tableDiv {
  height: calc(100% - 94px);
}

</style>
